<script>
import formCreate from '@/components/iglobalwin/formPanelGroups/index.js';
import formComponents from '@/components/iglobalwin/formComponents/common/index.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import utils from '@/utils';
import {
	required,
	regValid,
	requiredCustom,
} from '@/utils/validate';

const {
	skyInput,
	skySelect,
	skyTextarea,
	skyRadioBtn,
	skyCheckbox,
	skySelectInput,
	skyCheckboxPanel,
	skyCascaderPanel,
	// skyDatePicker,
	skyDatePickerRange,
	skyTiming,
} = formComponents;

function isEditPage(vm) {
	const edit = vm.$route.query.edit;
	const isEdit = edit !== null && edit !== undefined;
	return isEdit;
}

function getGroups(pageData, vm) {
	let { isEdit, geoList } = pageData;

	return {
		setting: {
			title: '广告系列基本设置',
			items: {
				campaignType: {
					label: '广告系列类型',
					type: skyRadioBtn,
					value: 'SEARCH',
					options: [
						{
							name: '搜索广告',
							code: 'SEARCH',
						},
					],
					// code: 'CampaignPlanType',
					rules: [required('请选择广告系列类型')],
				},
				name: {
					label: '广告系列名称',
					placeholder: '请输入广告系列名称',
					type: skyTextarea,
					value: '',
					rules: [required('请输入广告系列名称')],
					width: '50%',
					maxlength: '120',
					'show-word-limit': true,
					onChange: valueChange,
				},
				status: {
					label: '默认状态',
					type: skyRadioBtn,
					value: 'ENABLED',
					options: [
						{
							name: '启用',
							code: 'ENABLED',
						},
						{
							name: '暂停',
							code: 'PAUSED',
						},
					],
					// code: 'CampaignPlanType',
					rules: [required('请选择默认状态')],
				},
			},
		},
		budget: {
			title: '预算与出价',
			items: {
				budget: {
					label: '日预算',
					placeholder: '请输入日预算',
					type: skyInput,
					value: '',
					width: '50%',
					unit: '元',
					tip: '您每月的实际支出不会超过每日预算与一个月平均天数的乘积。有些天的实际支出可能低于每日预算，而有些天的实际支出最多可能会达到每日预算的两倍',
					rules: [
						required('请输入日预算'),
						regValid('请输入金钱格式','money')
					],
				},
				biddingStrategiesType: {
					label: '出价策略',
					type: skySelect,
					placeholder: '请选择出价策略',
					value: undefined,
					options: [
						{
							name: '每次点击费用人工出价',
							code: 1,
						},
					],
					width: '50%',
					rules: [required('请选择出价策略')],
					// multiple: true,
				},
				deviceType: {
					label: '设备出价调整',
					type: skyRadioBtn,
					value: '0',
					options: [
						{
							name: '不调整',
							code: '0',
						},
						{
							name: '调整',
							code: '1',
						},
					],
					// code: 'CampaignPlanType',
					rules: [required('请选择设备出价调整')],
				},
				tablet: {
					label: '平板电脑',
					type: skySelectInput,
					placeholder: '请输入',
					value: {
						type: 1,
						bidModifier: ''
					},
					options: [
						{
							name: '提高',
							code: 0,
						},
						{
							name: '降低',
							code: 1,
						},
					],
					unit: '%',
					width: '50%',
					visable(vm) {
						return vm.formData.fields.deviceType.value == 1;
					},
				},
				deskTop: {
					label: '计算机',
					type: skySelectInput,
					placeholder: '请输入',
					value: {
						type: 1,
						bidModifier: ''
					},
					options: [
						{
							name: '提高',
							code: 0,
						},
						{
							name: '降低',
							code: 1,
						},
					],
					unit: '%',
					width: '50%',
					visable(vm) {
						return vm.formData.fields.deviceType.value == 1;
					},
				},
				moile: {
					label: '手机',
					type: skySelectInput,
					placeholder: '请输入',
					value: {
						type: 1,
						bidModifier: ''
					},
					options: [
						{
							name: '提高',
							code: 0,
						},
						{
							name: '降低',
							code: 1,
						},
					],
					unit: '%',
					width: '50%',
					visable(vm) {
						return vm.formData.fields.deviceType.value == 1;
					},
				},
			},
		},
		pos: {
			title: '定位条件',
			items: {
				languageType: {
					label: '语言',
					type: skyRadioBtn,
					value: '1',
					options: [
						{
							name: '所有语言',
							code: '0',
						},
						{
							name: '指定语言',
							code: '1',
						},
					],
					// code: 'CampaignPlanType',
				},
				languages: {
					label: '选择语言',
					value: ['languageConstants/1000'],
					type: skyCheckboxPanel,
					options: [],
					dict: 'getLanguageList',
					title: '选择语言',
					props: {
						label: 'zhName',
						value: 'resourceName'
					},
					rules: [required('请选择语言')],
					visable(vm) {
						return vm.formData.fields.languageType.value == '1';
					},
				},
				locationType: {
					label: '国家/地区',
					type: skyRadioBtn,
					value: '0',
					options: [
						{
							name: '所有国家/地区',
							code: '0',
						},
						{
							name: '指定国家/地区',
							code: '1',
						},
					],
				},
				locations: {
					label: '指定国家/地区',
					value: {
						locations: [],
						exceptLocations: ['geoTargetConstants/2643','geoTargetConstants/2736','geoTargetConstants/2906'], // 默认制裁国家列表，固定排除且不可删除
					},
					type: skyCascaderPanel,
					options: geoList,
					attrs: {
						multiple: true,
						label: 'name',
						value: 'resourceName',
						children: 'children',
						num: 'num',
						emitPath: false,
						// checkStrictly: true,
					},
					// rules: [required('请选择指定国家/地区')],
					visable(vm) {
						return vm.formData.fields.locationType.value == '1';
					},
				},
				netWork: {
					label: '投放网络',
					value: ['targetGoogleSearch','targetSearchNetwork'],
					type: skyCheckbox,
					// code: 'PlatformType',
					options: [
						{
							name: 'Google搜索',
							code: 'targetGoogleSearch'
						},
						{
							name: '搜索网络合作伙伴',
							code: 'targetSearchNetwork'
						},
						{
							name: '展示广告网络',
							code: 'targetContentNetwork'
						},
					],
					filterOptions(data) {
						return data.map(item => {
							return {
								...item,
								disabled: () => {
									// google搜索必选，搜索网络合作伙伴默认勾选
									return item.code === 'targetGoogleSearch';
								},
							};
						});
					},
				},
			},
		},
		date: {
			title: '日期与时间',
			items: {
				dateType: {
					label: '投放时间类型',
					type: skyRadioBtn,
					value: '0',
					options: [
						{
							code: "0",
							name: '从今天开始长期投放'
						},
						{
							code: "1",
							name: '设置开始和结束时间'
						}
					],
					// code: 'DeliveryTimeType',
				},
				dates: {
					label: '投放时间',
					type: skyDatePickerRange,
					value: [],
					pickerType: 'date',
					width: '50%',
					pickerOptions: {
						disabledDate(time) {
							return time.getTime() < Date.now() - 3600 * 1000 * 24;
						},
					},
					rules: [
						requiredCustom('请选择投放时间 且 结束时间 >= 开始时间', function(val) {
							return new Date(val[0]).valueOf() <= new Date(val[1]).valueOf();
						})
					],
					visable(vm) {
						return vm.formData.fields.dateType.value == '1';
					},
				},
				adScheduleType: {
					label: '时间',
					type: skyRadioBtn,
					value: 0,
					options: [
						{
							code: 0,
							name: '不限'
						},
						{
							code: 1,
							name: '设置时间段'
						}
					],
					// code: 'DeliveryTimeType',
				},
				adSchedules: {
					label: ' ',
					type: skyTiming,
					value: [
						{
							dayOfWeek: '',
							startHour: '',
							endHour: '',
							resourceName: null
						}
					],
					rules: [
						requiredCustom('请选择时间周期 且 结束时间 >= 开始时间', function(val) {
							return val.every(item => {
								return (
									item['dayOfWeek'] &&
									item['startHour'] &&
									item['endHour'] &&
									compareTime(item['startHour']) <= compareTime(item['endHour'])
								);
							});
						})
					],
					tip: '提示：结束时间 >= 开始时间',
					visable(vm) {
						return vm.formData.fields.adScheduleType.value == 1;
					},
				},
			}
		}
	};
}

// 预加载数据
async function pageData(vm) {
	const isEdit = isEditPage(vm);
	const geoList = await getGeoList(); // 获取国家地区数据
	if (isEdit) {
		const detail = await getCampaignEditDetail(vm); //获取广告系列详情
		return {
			isEdit,
			detail,
			geoList,
		};
	} else {
		return {
			isEdit,
			geoList,
		};
	}
}

function getFormData({ pageData }, vm) {
	let { isEdit, detail } = pageData;
	const groups = getGroups(pageData, vm);
	if (isEdit) {
		return SetGroupFormValue(groups, detail);
	} else {
		return groups;
	}
}
// 编辑表单时value值回显填入
function SetGroupFormValue(groups, obj) {
	Object.keys(groups).forEach(groupKey => {
		Object.keys(groups[groupKey].items).forEach(itemKey => {
			// 如果obj[itemKey]不存在或者为空值时，表单则取自己原来的默认值。
			groups[groupKey].items[itemKey].value = obj[itemKey] || groups[groupKey].items[itemKey].value;
		});
	});
	return groups;
}

// 处理表单变化
async function valueChange(vm, field) {
	if(vm.errorMsgList && vm.errorMsgList.length) {
		vm.validateAll().then(msg => {
			vm.errorMsgList = msg;
		})
	}
}

// HH:mm转化时间为分钟
function compareTime(date) {
	let dateArr = date.split(':');
	let res = dateArr[0] * 60 + +dateArr[1];
	return res;
}

var details; // 详情数据
// 获取广告系列详情数据
async function getCampaignEditDetail(vm) {
	const res = await googleads.getCampaignEditDetail(vm.$route.query.edit);
	// details = Object.assign({},res.data);
	return res.data;
}

// 获取国家地区数据
async function getGeoList() {
	const res = await googleads.dictFun('getGeoList');
	return res.data;
}

// 筛选移除新增项
function filterRemoveItem(det, data, attr, key) {
	let arr = [];
	if(attr == 'add') {
		arr = data.filter(item => !det.includes(item));
	}else if(attr == 'remove') {
		if(key) {
			let res = data.filter(item => item[key]);
			det.forEach(item => {
				let isTrue = res.some(val => item[key] == val[key]);
				if(!isTrue) {
					arr.push(item);
				}
			});
		}else {
			arr = det.filter(item => !data.includes(item));
		}
		return arr;
	}
	return arr;
}

// 提交
async function submit(data) {
	// googleads.getChannelType();
	const isEdit = this.$route.query.edit;
	let res;
	if(isEdit) {
		details = await getCampaignEditDetail(this); //获取广告系列详情
		data['id'] = details.id; // 广告系列id
		data['campaignResourceName'] = this.$route.query.resourceName; // 广告系列资源
		data['campaignBudgetRseName'] = details.campaignBudgetResName; // 日预算资源
		data['delLanguages'] = filterRemoveItem(details['languages'], data['languages'],'remove'); // 语言删除项
		if(data['locationType'] == 1) {
			data['locations']['delLocations'] = filterRemoveItem(details['locations']['locations'], data['locations']['locations'],'remove'); // 删除国家地区项
			data['locations']['delExceptLocations'] = filterRemoveItem(details['locations']['exceptLocations'], data['locations']['exceptLocations'],'remove'); // 删除排除国家地区项
		}
		if(data['adScheduleType'] == 1) {
			data['delAdSchedules'] = filterRemoveItem(details['adSchedules'] || [], data['adSchedules'],'remove','resourceName'); // 删除时间项
		}
		// 编辑
		res = await googleads.getCampaignUpdate(data);
	}else {
		// 新建
		res = await googleads.addCampaign(data);
	}

	if(this.otherIsTrue) {
		// 跳转广告组
		this.$router.push({
			name: 'addAdGroup',
			query: {
				adSeriesId: res.data.id,
				adSeriesName: res.data.name,
				resourceName: res.data.resourceName,
			},
		});
	}else {
		goBack(this);
	}
	this.otherIsTrue = false;
	if(res.status == 200 && !res.data.error) {
		this.$message.success(isEdit ? '编辑广告系列成功！' : '新建广告系列成功！');
	}else {
		this.$message.error(isEdit ? '编辑广告系列失败！' : '新建广告系列失败！');
	}
}

function titleTooltipInfo() {
	return {
		tit: isEditPage(this) ? '编辑广告系列' : '新建广告系列',
		tip: [
			'广告系列：由一组使用相同的预算、地理位置定位和其他设置的广告组（广告、关键字和出价）组成。广告系列通常用于将您提供的产品或服务进行归类。',
			'Google Ads 帐号可投放一个或多个广告系列。',
			'· 每个广告系列包含一个或多个广告组。',
			'· 您可以在广告系列一级进行的设置包括预算、语言、地理位置、在 Google 广告网络中的投放范围，等等。',
			'· 您可以制作不同的广告系列，在不同的地理位置或使用不同的预算投放广告。',
		],
		// item: {
		// 	'所属广告系列': '测试广告系列'
		// }
	};
}

// 返回
function goBack(vm) {
	// 确认后返回广告系列列表
	vm.$router.push({
		name: 'accountManagement',
	});
}

// 取消-返回
function cancel(vm) {
	vm.$confirm('将不保存已填写的内容,是否确定关闭当前页面并返回广告系列列表？', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning',
	})
		.then(() => {
			goBack(vm);
		})
		.catch(() => {
			return;
		});
}

export default formCreate({
	getFormData,
	load: {
		pageData,
	},
	submit,
	cancel,
	showNavPanel: true,
	goBack,
	labelWidth: '180px',
	titleTooltip: true,
	titleTooltipInfo,
	otherBtn: true,
	otherBtnText: '保存并继续新建广告',
});
</script>
